// import "../Styles/Footer.css";
// import { Link } from "react-router-dom";
// import p1 from "../Images/Footer/payment1.svg";
// import p2 from "../Images/Footer/payment2.svg";
// import p3 from "../Images/Footer/payment3.svg";
// import p4 from "../Images/Footer/payment4.svg";
// import vat from "../Images/Footer/vat.svg";
// import logoAr from "../Images/comm1.png";
// import logoEn from "../Images/comm.png";
// import maroof from "../Images/Maroof.svg";
// import { useTranslation } from "react-i18next";

// function Footer() {
//   const { t, i18n } = useTranslation();
//   var dt = new Date();
//   const year = dt.getFullYear();
//   return (
//     <div id="footer" className="footer container-fluid">
//       <div className="container">
//         <div className="row gy-4">
//           <div className="col-sm-4 footerVat">
//             <img
//               className="footerLogo"
//               src={i18n.language == "ar" ? logoAr : logoEn}
//             />
//           </div>{" "}
//           <div className="col-sm-4 paymentMethods">
//             <img src={p3} /> <img src={p4} />{" "}
//           </div>{" "}
//           <div
//             className={
//               i18n.language == "ar"
//                 ? "col-sm-4 footerEndAr"
//                 : "col-sm-4 footerEnd"
//             }
//           >

//           </div>{" "}
//         </div>{" "}
//         <div className="copyRights">
//           <p>
//             {" "}
//             {t("footer.copy_write_parg")}© {year}{" "}
//           </p>{" "}
//           {/* Todo: add developed company to footer section */}
//           <p>
//             {" "}
//             {t("footer.developed_by")}
//             {": "}
//             <a href="https://www.nano2soft.com/ar" target="_blank" className="developedCompany">{t("footer.developed_company")}</a>
//           </p>{" "}
//         </div>{" "}
//       </div>
//     </div>
//   );
// }

// export default Footer;



import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaFacebookSquare, FaInstagram, FaTwitterSquare, FaWhatsapp, FaLinkedin, FaTiktok } from "react-icons/fa";
import logoAr from "../Images/comm1.png";
import logoEn from "../Images/comm.png";
import "../Styles/Footer.css";
import p3 from "../Images/Footer/payment3.svg";
import p4 from "../Images/Footer/payment4.svg";
import { getSettings } from "../api-nano";

function Footer() {
  const { t, i18n } = useTranslation();
  const year = new Date().getFullYear();
  const [settings, setSettings] = useState({});

  useEffect(() => {
    fetchSettingsData();
  }, []);

  const fetchSettingsData = async () => {
    try {
      const response = await getSettings();
      setSettings(response.data);
    } catch (error) {
      console.error('Error fetching proposals:', error);
    }
  };

  // Helper function to get social media icon
  const getSocialIcon = (name, icon) => {
    const nameLower = name?.toLowerCase() || '';
    const iconLower = icon?.toLowerCase() || '';
    if (nameLower.includes('facebook') || iconLower.includes('facebook')) 
      return <FaFacebookSquare />;
    if (nameLower.includes('twitter') || nameLower.includes('x') || iconLower.includes('twitter')) 
      return <FaTwitterSquare />;
    if (nameLower.includes('instagram') || iconLower.includes('instagram')) 
      return <FaInstagram />;
    if (nameLower.includes('whatsapp') || iconLower.includes('whatsapp')) 
      return <FaWhatsapp />;
    if (nameLower.includes('linkedin') || iconLower.includes('linkedin')) 
      return <FaLinkedin />;
    if (nameLower.includes('tiktok') || iconLower.includes('tiktok')) 
      return <FaTiktok />;
    return <FaFacebookSquare />; // Default fallback
  };

  // Get phones from settings
  const phones = settings?.phone || [];
  const emails = settings?.email || [];
  const socialLinks = settings?.social_links || [];
  const address = settings?.address || '';

  return (
    <footer className="footer">
      <div className="footer-content container">
        <div className="row">
          <div className="col-md-4">
            <img 
              src={i18n.language === "ar" ? logoAr : logoEn}
              alt="Rydan Logo" 
              className="footer-logo"
            />
            <p className="footer-description">{settings?.meta_description ?? ""}</p>
          </div>
          
          <div className="col-md-4">
            <h3>{t("footer.contact")}</h3>
            {address && <p>{address}</p>}
            {phones.map((phone, index) => (
              <p key={index}>
                {phone.phone_label && `${phone.phone_label}: `}
                <a href={`tel:${phone.phone_number}`}>{phone.phone_number}</a>
              </p>
            ))}
            {emails.map((email, index) => (
              <p key={index}>
                {email.email_label && `${email.email_label}: `}
                <a href={`mailto:${email.email_text}`}>{email.email_text}</a>
              </p>
            ))}
          </div>
          
          <div className="col-md-4">
            <h3>{t("footer.follow_us")}</h3>
            <div className="social-icons">
              {socialLinks.map((social, index) => (
                <a 
                  key={index}
                  href={social.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  title={social.name}
                >
                  {social.image ? (
                    <img src={social.image} alt={social.name} style={{ width: '30px', height: '30px' }} />
                  ) : (
                    getSocialIcon(social.name, social.icon)
                  )}
                </a>
              ))}
            </div>

            <div className="col-sm-4 payment-methods">
              <img src={p3} alt="payment method" /> 
              <img src={p4} alt="payment method" />
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {year} {t("footer.copy_write_parg")}</p>
          <p style={{
            fontSize: "14px"
          }}>
            {t("footer.developed_by")}: <a href="https://www.nano2soft.com/ar" target="_blank" rel="noopener noreferrer" ><span>{t("footer.developed_company")}</span></a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;